import React from 'react';

function App() {
  return (
    <div className="min-h-screen bg-white text-gray-800 font-sans">
      <header className="text-center p-10 bg-gradient-to-r from-indigo-500 to-purple-600 text-white">
        <h1 className="text-4xl font-bold mb-2">Quantreon Inc.</h1>
        <p className="text-xl">Shaping the Quantum Future</p>
        <a
          href="mailto:hello@quantreon.ai"
          className="mt-4 inline-block px-6 py-2 bg-white text-indigo-700 rounded-full font-semibold hover:bg-gray-100"
        >
          Join the Quantum Revolution
        </a>
      </header>

      <section className="p-10 max-w-3xl mx-auto">
        <h2 className="text-2xl font-bold mb-4">Problem We Solve</h2>
        <p>
          Classical systems are nearing their limits. Quantreon bridges the gap between
          theoretical quantum research and real-world scalable applications.
        </p>
      </section>

      <section className="p-10 bg-gray-50 max-w-3xl mx-auto">
        <h2 className="text-2xl font-bold mb-4">Our Mission</h2>
        <p>
          We accelerate the quantum transition by developing hardware/software for AI, encryption, and sensing.
        </p>
      </section>

      <section className="p-10 max-w-3xl mx-auto">
        <h2 className="text-2xl font-bold mb-4">Meet the Founder</h2>
        <p className="mb-2 font-semibold">Harsha Vardhan Gundrathi</p>
        <p>
          Passionate about quantum systems, edge AI, and avionics. Building Quantreon to bring quantum possibilities to life.
        </p>
      </section>

      <section className="p-10 bg-gray-100 max-w-3xl mx-auto">
        <h2 className="text-2xl font-bold mb-4">Contact Us</h2>
        <p>
          Interested in collaboration or investment? Email us at{' '}
          <a className="text-blue-600 underline" href="mailto:hello@quantreon.ai">
            hello@quantreon.ai
          </a>
        </p>
      </section>

      <footer className="text-center p-6 bg-gray-900 text-white">
        © 2025 Quantreon Inc. | hello@quantreon.ai
      </footer>
    </div>
  );
}

export default App;
